import styled from 'styled-components';
import { FontAwesomeIcon } from '../../../../../../module/ui/components/atoms/icon/icon';

export const CommandListItemIcon = styled(FontAwesomeIcon).attrs({
  size: 12,
})`
  color: var(--icon-secondary);
`;
